import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  updateDoc
} from "firebase/firestore";
import Moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Image
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { FaLocationArrow } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import Msgpic from "../../assets/user.png";
import Loader from "../../Components/Loader/Loader";
import { db } from "../../Firebase";
import { InsertChatApi } from "../../Utils/Api/InsertChat";
import { getUser } from "../../Utils/LocalStorage";

const Chat = ({ ToggleChat, selectedChannel, ...props }) => {
  const navigate = useNavigate();
  const get_uuid = uuidv4();
  const parameter = useParams();
  const location = useLocation();
  const com_id = parameter?.id;
  const flag = parameter.flag;
  const userId = localStorage.getItem("Bu_userId");
  const userData = getUser();
  const BunsinessName = location.state.businessName;
  const ProductName = location.state.productName;
  const profileImage = location.state.profileImage;
  const firstName = location.state.firstName;
  const [chatMessage, setChatMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [allMessages, setAllMessages] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const split_com_id = com_id.split("_");
  const product_type = split_com_id[2];
  const product_id = split_com_id[3];

  // const ReduxData = useSelector((state) => state.PersistedData.ChatFlag);

  // const GeneralFlag = ReduxData.ChatFlagGeneral;
  // const OrderFlag = ReduxData.OrderFlagGeneral;

  // console.log("locationlocation", location);
  // console.log("parameter", parameter);
  // console.log("userId", userId);
  // console.log("receiverId", split_com_id);
  useEffect(() => {
    updateChatField();
    if (com_id) {
      CallFirebaseChat();
      // const unsub = onSnapshot(
      //   query(
      //     collection(
      //       db,
      //       com_id,
      //     ),
      //     orderBy("timestamp")
      //   ),
      //   (snapshot) => {
      //     setAllMessages(
      //       snapshot.docs.map((doc) => ({
      //         id: doc.id,
      //         messages: doc.data(),
      //         read: doc.data().read,
      //         userId: doc.data().messageUserId,
      //         receiverd: doc.data().messagereceiverId
      //       }))
      //     );
      //   }
      // );
      // return unsub;
    }
  }, [com_id]);

  const CallFirebaseChat = async () => {
    const getcollection = query(collection(db, com_id), orderBy("createdAt"));
    const collectionSnapshot = await getDocs(getcollection);
    const getchatList = setAllMessages(
      collectionSnapshot.docs.map((doc) => ({
        id: doc.data()._id,
        messages: doc.data().text,
        createdAt: doc.data().createdAt,
        user_id: doc.data().user._id,
        user_name: doc.data().user.name,
      }))
    );
    return getchatList;
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    // setLoading(true);
    if (chatMessage === "" || com_id === "voucher_coupon") {
      setErrorMessage("Please Enter Some Message!");
    } else {
      try {
        if (userId && com_id !== "voucher_coupon") {
          await addDoc(collection(db, com_id), {
            _id: get_uuid,
            text: chatMessage,
            createdAt: new Date(),
            user: {
              _id: userId,
              name: BunsinessName,
            },
          });
          navigate(`/messages/${com_id}`, {
            state: { productName: ProductName, businessName: BunsinessName },
          });
          CallFirebaseChat();
          let messageData = {
            bu_id: userId,
            channel_id: com_id,
            product_id: product_id,
            help_reason: chatMessage,
            product_type: product_type === "voucher" ? 1 : 2,
          };
          InsertChattoDB(messageData);

          // toSendReceiverNotification();
          // setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
      setChatMessage("");
    }
  };
  const InsertChattoDB = async (messageData) => {
    const MessageData = await InsertChatApi(messageData, () => {
      navigate("/");
    });
    setLoading(true);
    if (MessageData.status === 200) {
      navigate(`/messages/${com_id.toString()}`, {
        state: { productName: ProductName, businessName: BunsinessName },
      });
      setLoading(false);
    } else if (MessageData.status == 429) {
      setLoading(true);
      toast.error(MessageData.message, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };
  // enter-button(priya)
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      sendMessage(e);
    }
  };

  // const toSendReceiverNotification = async () => {
  //   setLoading(true);
  //   const data = {
  //     sender_id: userId,
  //     receiver_id: product_id,
  //     message: chatMessage,
  //   };
  //   const NotificationData = await SendMessageNotificationApi(data); // sending notification to receiver system
  // };

  const updateChatField = () => {
    let docID = "";
    allMessages.forEach((doc) => {
      if (doc.read == false && doc.userId !== userData.user_id) {
        docID = doc.id;
        chatUpdate(docID);
      }
    });
  };
  async function chatUpdate(docID) {
    const user = doc(db, com_id, docID);
    const query = await updateDoc(user, {
      read: true,
    });
  }

  if (
    com_id != "voucher_coupon" &&
    ToggleChat === false &&
    selectedChannel.id !== ""
  ) {
    return (
      <>
        {loading ? <Loader /> : ""}
        <div className="chat-main mt-3">
          <div className="chat-header">
            <div className="d-flex msg-main1 msg-main2">
              <div className="msgpic">
                <Image
                  loading="lazy"
                  src={profileImage ? profileImage : Msgpic}
                  className="msgpic"
                ></Image>
              </div>
              <div className="msg-1">
                <p className="msg1-text1 orange_Text">{firstName}</p>
                <p className="msg1-text1">{ProductName}</p>
                <p className="msg1-text2">{BunsinessName}</p>
              </div>
            </div>
          </div>
          <div className="container bootstrap snippets bootdeys">
            <div className="col-md-12">
              <div className="panel" id="chat">
                <div className="panel-body">
                  <div className="chats">
                    {allMessages &&
                      allMessages.map((allMessages) => {
                        let Time = new Date(
                          allMessages.createdAt.toDate("dd/mm/yyyy")
                        ).toLocaleString();
                        return (
                          <div>
                            {allMessages.user_name !== BunsinessName &&
                            allMessages.text !== "" ? (
                              <div className="chat chat-left">
                                <div className="chat-body">
                                  <div className="chat-content">
                                    <p style={{ color: "black" }}>
                                      {allMessages.messages}
                                    </p>
                                    <time
                                      className="chat-time"
                                      datetime="2015-07-01T11:39"
                                    >
                                      {Moment(Time).format("DD-MMM-YY hh:mm A")}
                                    </time>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {allMessages.user_id === userId &&
                            allMessages.user_name === BunsinessName &&
                            allMessages.text !== "" ? (
                              <div className="chat">
                                <div className="chat-body">
                                  <div className="chat-content">
                                    <p style={{ color: "black" }}>
                                      {allMessages.messages}
                                    </p>
                                    <time
                                      className="chat-time"
                                      datetime="2015-07-01T11:40"
                                    >
                                      {Moment(Time).format("DD-MMM-YY hh:mm A")}
                                    </time>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        );
                      })}
                  </div>
                </div>
                <div className="panel-footer">
                  <form>
                    <div className="input-group">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          type="input"
                          value={chatMessage}
                          onChange={(e) => setChatMessage(e.target.value)}
                          placeholder="Type a message..."
                          onKeyPress={handleKeypress}
                          autoComplete="off"
                        />
                        <button
                          className="btn btn-primary chat-send"
                          type="button"
                          onClick={(e) => sendMessage(e)}
                        >
                          <FaLocationArrow />
                        </button>
                      </Form.Group>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};

Chat.propTypes = {};

export default Chat;
